import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { backend } from '../axios/backend';
import { Idea } from '../pages/IdeasForPersonPage';
import { PersonResponse } from '../pages/MyIdeasPage';

export type IdeasForPersonResponse = {
  person: PersonResponse;
  ideas: Idea[];
};

export const useIdeas = (
  personId: string,
  options?: UseQueryOptions<unknown, AxiosError, IdeasForPersonResponse, string[]>,
) => {
  return useQuery(
    ['ideas', personId],
    async () => (await backend.get<IdeasForPersonResponse>(`person/${personId}/ideas`)).data,
    options,
  );
};
